import { jsx } from 'react/jsx-runtime';
import { useMemo, useEffect } from 'react';
import { SideSheetPortal } from '@circlefin/components';
import { useSideSheet } from '../useSideSheet/index.js';

const SideSheetRouter = ({ children })=>{
    const { current, router } = useSideSheet();
    const isOpen = useMemo(()=>{
        return current != null;
    }, [
        current
    ]);
    useEffect(()=>{
        if (typeof window === 'undefined') return;
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') {
                router.clear();
            }
        };
        if (isOpen) {
            window.addEventListener('keydown', handleKeyDown);
        }
        return ()=>{
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        isOpen,
        router
    ]);
    return jsx(SideSheetPortal, {
        isOpen: isOpen,
        children: children
    });
};

export { SideSheetRouter };
//# sourceMappingURL=SideSheetRouter.js.map
